import { render } from "./tonglianPrecisionTube.vue?vue&type=template&id=2347f5f4&scoped=true"
import script from "./tonglianPrecisionTube.vue?vue&type=script&lang=js"
export * from "./tonglianPrecisionTube.vue?vue&type=script&lang=js"

import "./tonglianPrecisionTube.vue?vue&type=style&index=0&id=2347f5f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2347f5f4"

export default script